import { AxiosResponse } from 'axios';
import requestClient from '../components/Utility/RequestClient';
import {
    OpenApiConfig,
    OpenApiTestRequest,
    OpenApiTestResponse,
    OpenApiConfigFormData,
    OpenApiConfigResponse,
} from '../Types';
import { StoreEnvironment } from '../Types/StoreTypes';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const openApiService = {
    getConfigs: (
        demo: boolean,
        page = 1,
        itemsPerPage = 30,
        optionalParams?: Record<string, string>,
        query: string | null = null,
    ): Promise<AxiosResponse<{ data: OpenApiConfig[]; total: number }>> => {
        const base = demo ? '/demo' : '';
        return requestClient.get(`${base}/openapi/configs`, {
            params: { page, itemsPerPage, query },
        });
    },

    getConfig: (identifier: string, query?: { [key: string]: any }): Promise<AxiosResponse<any>> => {
        const base = resolveDemo() ? '/demo' : '';
        return requestClient.get(`${base}/openapi/configs/${identifier}`, { params: query });
    },

    getEndpoints: (
        identifier: string,
        page: number = 1,
        itemsPerPage: number = 10,
        query: string | null = null,
    ): Promise<AxiosResponse<{ data: any[]; total: number }>> => {
        const base = resolveDemo() ? '/demo' : '';
        return requestClient.get(`${base}/openapi/configs/${identifier}/endpoints`, {
            params: { page, itemsPerPage, query },
        });
    },

    createConfig: (data: OpenApiConfigFormData): Promise<AxiosResponse<OpenApiConfigResponse>> => {
        const base = resolveDemo() ? '/demo' : '';
        return requestClient.post(`${base}/openapi/configs`, data);
    },

    updateConfig: (identifier: string, data: OpenApiConfigFormData): Promise<AxiosResponse<OpenApiConfigResponse>> => {
        const base = resolveDemo() ? '/demo' : '';
        return requestClient.put(`${base}/openapi/configs/${identifier}`, data);
    },

    deleteConfig: (identifier: string): Promise<AxiosResponse<{ message: string }>> => {
        const base = resolveDemo() ? '/demo' : '';
        return requestClient.delete(`${base}/openapi/configs/${identifier}`);
    },

    testEndpoint: (identifier: string, data: OpenApiTestRequest): Promise<AxiosResponse<OpenApiTestResponse>> => {
        const base = resolveDemo() ? '/demo' : '';
        return requestClient.post(`${base}/openapi/test/${identifier}`, data);
    },
};
